import React, { useState, useEffect } from 'react';
import './CookieConsent.css';

function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setTimeout(() => setIsVisible(true), 1000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'true');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'false');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-consent">
      <div className="cookie-consent__content">
        <div className="cookie-consent__cookie">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
            <g id="cookie">
              <path fill="#BA7F50" d="M214.798,131.338c-2.72-13.935-10.356-13.564-13.691-22.145c-1.952-5.02-8.01-7.696-12.273-12.958
                c-4.028-4.972-11.228-5.879-14.996-6.775c-7.534-1.795-15.428-2.513-22.244-0.36c-6.818,2.152-13.903,3.176-21.17,3.23
                c-6.128,0.043-12.377,3.742-15.786,9.328c-2.696,4.417-2.513,11.123-6.101,13.992c-3.587,2.871-7.096,3.626-8.969,7.535
                c-3.551,7.413-1.436,13.276-2.511,17.223c-1.078,3.946-3.588,10.763-2.513,18.299c1.076,7.533,0.65,10.361,5.74,15.069
                c2.012,1.858,4.665,2.511,6.1,7.893c1.438,5.383,9.688,13.274,17.222,16.505c7.537,3.229,9.778-1.492,16.227,2.707
                c5.971,3.888,13.023,4.173,19.448,3.795c7.785-0.459,10.518-2.298,13.844-3.795c7.174-3.23,9.064-7.168,16.521-7.892
                c6.688-0.646,17.002-6.402,19.713-17.419c2.443-9.932,7.352-12.458,6.182-19.325
                C213.813,146.133,216.779,141.476,214.798,131.338z"/>
              <circle fill="#663F31" cx="160" cy="110" r="8"/>
              <circle fill="#663F31" cx="130" cy="125" r="6"/>
              <circle fill="#663F31" cx="185" cy="125" r="7"/>
              <circle fill="#663F31" cx="155" cy="190" r="6"/>
              <circle fill="#663F31" cx="120" cy="180" r="5"/>
              <circle fill="#663F31" cx="195" cy="165" r="6"/>
            </g>
          </svg>
        </div>
        <p className="cookie-consent__text">
          We use cookies to enhance your browsing experience and analyze site traffic. By continuing to use this site, you agree to our use of cookies.
        </p>
        <div className="cookie-consent__buttons">
          <button onClick={handleAccept} className="cookie-consent__btn cookie-consent__btn--accept">
            Accept
          </button>
          <button onClick={handleDecline} className="cookie-consent__btn cookie-consent__btn--decline">
            Decline
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;

